import React, { useState, useRef } from 'react';
import { Form, Input, Button, Table, DatePicker, Select, Space, message, Breadcrumb, ConfigProvider, Card } from 'antd';
import { useAntdTable, useSize } from 'ahooks';
import { WalletOutlined } from '@ant-design/icons';
import moment from 'moment';
import zhCN from 'antd/lib/locale/zh_CN';
import request from '../../../../utils/request';
import MyButton from '../../../../components/MyButton';
import styles from './index.module.scss';
import { getToken } from '../../../../utils/cookie';
import { useSelector } from 'react-redux'

const { RangePicker } = DatePicker;
const { Option } = Select;

const EQUITY_TYPE_OPTIONS = [
  { label: '全部', value: '' },
  { label: '权益充值', value: 'EQUITY_TOPUP' },
  { label: '权益扣除', value: 'EQUITY_DEDUCT' },
  { label: '权益冻结', value: 'EQUITY_FREEZE' },
];

const EquityRecord = () => {
  const [form] = Form.useForm();
  const [stats, setStats] = useState({
    sum_topup_equity_point: 0,
    sum_deduct_equity_point: 0,
    sum_freeze_equity_point: 0,
    remaining_equity_point: 0,
  });

  // 用于计算表格高度
  const tableWrapperRef = useRef(null);
  const size = useSize(tableWrapperRef);
  const userInfo = useSelector((state) => state.login.userInfo)
  
  // 获取基础域名
  const getBaseUrl = () => {
    return process.env.REACT_APP_BASE_URL || window.location.origin;
  };

  const getTableData = async ({ current, pageSize }, formData) => {
    const { equity_chg_time, ...rest } = formData;
    
    console.log(userInfo)
    const params = {
      page: current,
      page_size: pageSize,
      record_type: userInfo?.co_type_code === 'INDIV_ORG' ? 'PERSONAL' : 'ENTERPRISE', // 默认企业类型
      ...rest,
    };

    //个人版企业传个人id,企业版传企业id
    if(userInfo?.co_type_code === 'INDIV_ORG'){
      params.user_id = userInfo.co_user_id
    } else {
      params.co_id = userInfo.co_id
    }

    if (equity_chg_time && equity_chg_time.length === 2) {
      params.equity_chg_time_start = moment(equity_chg_time[0]).format('YYYY-MM-DD HH:mm:ss');
      params.equity_chg_time_end = moment(equity_chg_time[1]).format('YYYY-MM-DD HH:mm:ss');
    }

    try {
      const res = await request({
        url: '/api/opm/topup/equity/list/',
        method: 'get',
        baseURL: getBaseUrl(),
        notMsg: true,
        params,
      });

      if (res.data && res.data.code === 0) {
        // 更新统计数据
        if (res.data.data.stat) {
          setStats(res.data.data.stat);
        }
        return {
          total: res.data.data.total_count,
          list: res.data.data.data,
        };
      } else {
        message.error(res.data.message || '获取权益记录失败');
        return { total: 0, list: [] };
      }
    } catch (error) {
      message.error('系统错误，请稍后重试');
      return { total: 0, list: [] };
    }
  };

  const { tableProps, search } = useAntdTable(getTableData, {
    defaultPageSize: 10,
    form,
    refreshDeps: [userInfo],
  });

  const { submit } = search;

  const columns = [
    // {
    //   title: userInfo?.co_type_code === 'INDIV_ORG' ? '用户(手机号/昵称)' : '企业 (编号/名称)',
    //   key: 'company',
    //   ellipsis: true,
    //   className: 'paddingHeader',
    //   render: (_, record) => (
    //     userInfo?.co_type_code === 'INDIV_ORG' ?
    //     <span>
    //       <span style={{ color: '#8c8c8c' }}>{record.user_phone}</span>
    //       <span style={{ margin: '0 4px', color: '#d9d9d9' }}>/</span>
    //       <span>{record.show_name}</span>
    //     </span>
    //     :
    //     <span>
    //       <span style={{ color: '#8c8c8c' }}>{record.co_code}</span>
    //       <span style={{ margin: '0 4px', color: '#d9d9d9' }}>/</span>
    //       <span>{record.co_name}</span>
    //     </span>
    //   ),
    // },
    {
      title: '权益变动类型',
      dataIndex: 'equity_chg_type_name',
      key: 'equity_chg_type_name',
      className: 'paddingHeader',
      ellipsis: true,
      render: (_, record) => (
        <span>
          {EQUITY_TYPE_OPTIONS.find(item => item.value === record.equity_chg_type_code)?.label || '-'}
        </span>
      ),
    },
    {
      title: '变动时间',
      dataIndex: 'equity_chg_time',
      key: 'equity_chg_time',
      ellipsis: true,
    },
    {
      title: '摘要',
      dataIndex: 'summary',
      key: 'summary',
      ellipsis: true,
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      ellipsis: true,
      render: (text) => <span>{text || '-'}</span>,
    },
    {
      title: '权益点',
      dataIndex: 'equity_point',
      key: 'equity_point',
      width: 120, // 权益点数字较短且需要对齐，保留宽度更佳，但如果用户强行要求也可移除
      render: (val, record) => {
        const num = Number(val);
        const type = record.equity_chg_type_code;
        let color = '#8c8c8c';
        let prefix = '';

        if (type === 'EQUITY_TOPUP') {
          color = '#52c41a';
          prefix = '+';
        } else if (type === 'EQUITY_DEDUCT' || type === 'EQUITY_FREEZE') {
          color = '#f5222d';
          prefix = '-';
        }

        return <span style={{ color, fontWeight: '500', fontSize: 16 }}>{prefix}{Math.abs(num).toLocaleString()}</span>;
      },
    },
  ];

  // 处理充值点击
  const handleTopUp = () => {
    message.info('充值功能开发中...');    
  };

  return (
    <ConfigProvider locale={zhCN}>
      <div className={styles.equityRecordWrapper}>
        <div className="right_content">
          {/* 面包屑 */}
          <Breadcrumb>
            <Breadcrumb.Item>账户管理</Breadcrumb.Item>
            <Breadcrumb.Item>权益记录</Breadcrumb.Item>
          </Breadcrumb>

          {/* 搜索卡片 (包含统计行) */}
          <Card className="search-card">
            <div className={styles.searchHeader}>
              <Form form={form} className="form-search" layout="inline">
                <Form.Item name="equity_chg_time" label="权益变动时间">
                  <RangePicker style={{ width: 240 }} allowClear onChange={submit} />
                </Form.Item>
                <Form.Item name="equity_chg_type_code" label="权益变动类型">
                  <Select placeholder="全部" style={{ width: 140 }} allowClear onChange={submit}>
                    {EQUITY_TYPE_OPTIONS.map(opt => (
                      <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="summary" label="摘要">
                  <Input placeholder="请输入" style={{ width: 160 }} onPressEnter={submit} allowClear />
                </Form.Item>
              </Form>
            </div>
            {/* 统计数据 */}
            <div className={styles.statsRow}>

              <div className={styles.statItem}>
                <span className={styles.statLabel}>累计充值权益点</span>
                <span className={styles.statValue} style={{ color: '#006AB2' }}>
                  {Number(stats.sum_topup_equity_point || 0).toLocaleString()}
                </span>
              </div>
              
              <div className={styles.statItem}>
                <span className={styles.statLabel}>冻结权益点</span>
                <span className={styles.statValue} style={{ color: '#FE545F' }}>
                  {Number(stats.sum_freeze_equity_point || 0).toLocaleString()}
                </span>
              </div>
              
              <div className={styles.statItem}>
                <span className={styles.statLabel}>累计使用</span>
                <span className={styles.statValue} style={{ color: '#FE545F' }}>
                  {Number(stats.sum_deduct_equity_point || 0).toLocaleString()}
                </span>
              </div>

              <div className={styles.statItem}>
                <span className={styles.statLabel}>剩余权益点</span>
                <span className={styles.statValue} style={{ color: '#61D4AD' }}>
                  {Number(stats.remaining_equity_point || 0).toLocaleString()}
                </span>
              </div>
              
            </div>
          </Card>

          {/* 表格区域 */}
          <div className="right_table" ref={tableWrapperRef}>
            <Table
              columns={columns}
              rowKey="id"
              {...tableProps}
              size="small"
              scroll={{ y: size ? size.height - 95 + 'px' : 400 }}
              pagination={{
                ...tableProps.pagination,
                showTotal: (total) => `共 ${total} 条`,
                showQuickJumper: true,
                showSizeChanger: true,
              }}
            />
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
};

export default EquityRecord;
